// extracted by mini-css-extract-plugin
module.exports = {"avatarRightBox":"AvatarMenu_avatarRightBox_3fp6G"};